export default "__VITE_ASSET__8f55464e__"